import React from 'react'
import tw from 'tailwind-styled-components'

type Background = {
  $bgOpacityClassName: string
  $bgColorClassName: string
  $bgPosition: string
}

const TwContainer = tw.div<{$className: string}>`
  relative
   ${({$className}) => `
    ${$className}
  `}
`

const TwBackground = tw.div<Background>`
  ${({$bgOpacityClassName, $bgColorClassName, $bgPosition}) => `
    ${$bgOpacityClassName}
    ${$bgColorClassName}
    ${$bgPosition}
  `}
  w-full
  h-full
  absolute
  z-0
`
const TwChildren = tw.div`
  relative
  z-1
  h-full
`

export interface BgOpacityContainerProps {
  children: React.ReactNode
  bgOpacityClassName?: string
  bgColorClassName?: string
  className?: string
  childrenClassName?: string
  bgPosition?: string
}

export const BgOpacityContainer = (props: BgOpacityContainerProps) => {
  const {
    children,
    className = '',
    childrenClassName = '',
    bgOpacityClassName = 'opacity-90',
    bgColorClassName = 'bg-main-old',
    bgPosition = 'top-0 left-0'
  } = props
  return (
    <TwContainer $className={className}>
      <TwBackground
        $bgOpacityClassName={bgOpacityClassName}
        $bgColorClassName={bgColorClassName}
        $bgPosition={bgPosition}
      />
      <TwChildren className={childrenClassName}>{children}</TwChildren>
    </TwContainer>
  )
}
